import React from 'react'
import {Container, Row, Col} from 'reactstrap'

export default () => 
  <Container>
    <Row>
      <Col>Table Test</Col>
    </Row>
    <Row>
      <Col>Test 1</Col>
      <Col>Test 2</Col>
    </Row>
  </Container>




// WEBPACK FOOTER //
// ./src/pages/test.js